import React from 'react';
import { IIcon, useIconProps } from '../useIconProps';
import PresentSvgIcon from './present.svgrIcon.svg';

export const PresentIcon = React.forwardRef(({ ...props }: IIcon, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    ...props,
  });

  return <PresentSvgIcon {...iconProps} />;
});
